import { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { LoadableStatus } from '../mobx-utils';
import { parseHtml } from '../core/utils';
import { useStore } from '../core/store';

import { ContentWrapper } from '../components/content-wrapper';
import { LoadSpinner, Loader } from '../components/loader';
import { PageWrapper } from '../components/page-wrapper';
import { urls } from '../urls';
import { usePeopleAndPlacesContent } from '../hooks/usePlacesAndPeopleContent';

export const imageSliderConfig = {
  modules: [
    //
    Navigation,
    Pagination,
    Autoplay,
  ],
  navigation: true,
  pagination: { dynamicBullets: true },
  slidesPerView: 1,
  spaceBetween: 0,
};

export const PeopleAndPlaces = observer(() => {
  const navigate = useNavigate();
  const { BookingStore } = useStore();
  let { content, loading } = usePeopleAndPlacesContent();

  // Redirect if not valid booking type
  if (BookingStore?.booking?.status !== LoadableStatus.done) {
    return <Loader />;
  }

  let isTurkeyBooking =
    BookingStore?.booking?.data?.serviceName?.charAt(1) === 'T';

  if (!isTurkeyBooking) navigate(urls.home);

  if (loading !== false) {
    return <LoadSpinner />;
  }

  return (
    <PageWrapper>
      <div className="w-full h-[400px] relative">
        <img
          className="w-full h-full object-cover"
          src={'/public/assets/images/teasers/land-und-leute.png'}
        />
      </div>
      <ContentWrapper>
        <div className="pwa-content">{parseHtml(content)}</div>
      </ContentWrapper>
    </PageWrapper>
  );
});
